import { NgModule } from '@angular/core';
import { NgbDropdownModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { FiltersComponent } from './filters.component';
import { SharedProviderModule } from '../../shared/shared.module';
import { QmPipesModule } from '../../components/qm-pipes/qm-pipes.module';
import { QmDirectivesModule } from '../../components/qm-directives/qm-directives.module';

@NgModule({
  imports: [
    SharedProviderModule,
    NgbDropdownModule,
    QmPipesModule,
    QmDirectivesModule,
    NgbTypeaheadModule
  ],
  declarations: [FiltersComponent],
  providers: [],
  exports: [FiltersComponent]
})
export class FiltersModule {
}
